// gloss
export const isEmbedMode = () => {
  if (typeof window === 'undefined') return false;
  const isFramed = window.parent !== window;
  const isEmbedPath = /^\/embed(\/|$)/.test(window.location.pathname);
  const isEmbedParam = new URLSearchParams(window.location.search).get('embed') === 'true';
  return isFramed || isEmbedPath || isEmbedParam;
};

export const sendMessageToParent = (type, data = {}) => {
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        type,
        ...data,
      },
      '*',
    );
  }
};

export const MODAL_MESSAGES = {
  OPEN: 'MODAL_OPEN',
  CLOSE: 'MODAL_CLOSE',
};

export const AUTH_MESSAGES = {
  AUTH_REQUIRED: 'zealot:auth_required',
};
